<template>
  <div class="c-modal-container">
    <slot/>
  </div>
</template>

<style lang="scss">
  .c-modal-container {
    width: 50rem;
    max-width: calc(100vw - 10rem);
    margin: 5rem auto;
    z-index: $modal-layer;
    position: relative;

    &:not(:last-child) {
      display: none;
    }

    &:has(.c-modal-large) {
      width: 80rem;
    }

    $sidebar-width: 25rem;
    &:has(.c-modal-right) {
      width: $sidebar-width;
      margin: 0  0  0 auto;
    }

    &:has(.c-modal-left) {
      width: $sidebar-width;
      margin: 0;
    }
  }
</style>